import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyDZ1f5b5l2MW-93qatCDBDXsBgWyfJZ5Jc",
  authDomain: "udemy-vue-chat-e15ce.firebaseapp.com",
  projectId: "udemy-vue-chat-e15ce",
  storageBucket: "udemy-vue-chat-e15ce.appspot.com",
  messagingSenderId: "924483173902",
  appId: "1:924483173902:web:0fd38c7f04e9979ee9865f"
};

// init firebase
firebase.initializeApp(firebaseConfig)

const projectAuth = firebase.auth()
const projectFirestore = firebase.firestore()
const timestamp = firebase.firestore.FieldValue.serverTimestamp

export { projectAuth, projectFirestore, timestamp }
